const jwt_customizer = {
    general: 'Ocorreu um erro ao personalizar o token JWT. Por favor, tente novamente mais tarde.',
    can_not_create_for_admin_tenant: 'Não é possível criar um personalizador de token JWT para o inquilino admin.',
};
export default Object.freeze(jwt_customizer);
